var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.delta > 0)?_c('div',{staticClass:"txt-webinar-begins"},[_vm._v(_vm._s(_vm.headline))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"txt-webinar-countdown"},[_vm._v("\n        "+_vm._s(_vm.prettyCountdown)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52decf19","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Countdown.vue
// module id = null
// module chunks = 